<template>
    <div class="home-wrapper flex-height-max">
        <div class="home-wrapper-container">
            <div v-if="progress_bar_percentage > 0">
                <div class="progress">
                    <div class="progress-bar bg-success" role="progressbar" v-bind:style="'width:'+progress_bar_percentage+'%;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{progress_bar_text}}</div>
                </div>
                <div style="text-align: left; font-size: 12px;">Setup progress</div>
            </div>
            <template>
                <div class="flex-height-max flex-row">
                    <div class="content">
                        <div class="header-home">
                            ⚠️Oops! We don’t support MCC accounts (yet).
                        </div>
                        <div style="font-size: 16px;">
                            Our system detected that you tried to connect your MCC account to our service.
                        </div>
                        <div class="mt-3">At the moment, we don't support automatic integration with MCC accounts. If you want to protect all of your sub-accounts, please submit their IDs one by one. Alternatively, you can enjoy our free setup assistance from a dedicated integration specialist. To book an integration session, <a style="text-decoration: underline; color: blue;" :href="'https://calendly.com/galia-s/ppc-shield-setup-assistance?a1='+user_id">click here</a>.</div>
                        <button class="btn btn-success w-100 mt-3" v-on:click="connectAnotherAccount">CONNECT SUB-ACCOUNT</button>
                        <button class="btn btn-primary w-100 mt-3" style="margin-bottom: 80px;" v-on:click="goToAccountPage">GO TO DASHBOARD</button>
                    </div>
                    <div class="content-right-side">
                        <img class="right-img" src="/images/undraw_warning_cyit.svg" alt="dont support">
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['user_id', 'progress_bar_percentage', 'progress_bar_text'],
        data: function () {
            return {

            }
        },
        methods: {
            goToAccountPage(){
                window.location = "/account";
            },
            connectAnotherAccount(){
                window.location = "/setup/connectGoogleAds";
            },
        },
        mounted() {

        }
    }
</script>
